<template>
	<div class="cm-container" :style="axisComputed" v-if="show">
		<svg aria-hidden="true" style="position: absolute; width: 0px; height: 0px; overflow: hidden;">
			<symbol id="icon-youjiantou" viewBox="0 0 1024 1024">
				<path d="M288.791335 65.582671l446.41733 446.417329-446.41733 446.417329z"></path>
			</symbol>
		</svg>
		<!--first-->
		<ul class="cm-ul cm-ul-1 easy-cm-ul"
			:class="underline?'cm-underline':''">
			<li v-for="(item, index) in list" :style="liStyle">
				<div @click.stop="callback(item, [index])"
					 :class="firstLeft?'cm-left':''">
					<i :class="item.icon"></i>
					<span>{{item.text}}</span>
					<svg class="icon" aria-hidden="true"
						 v-if="arrow && item.children && item.children.length > 0">
						<use xlink:href="#icon-youjiantou"></use>
					</svg>
				</div>
				<!--second-->
				<ul class="cm-ul cm-ul-2 easy-cm-ul"
					:style="secondBorderCheck(index)"
					:class="underline?'cm-underline':''"
					v-if="item.children && item.children.length > 0">
					<li v-for="(second, si) in item.children"
						:style="liStyle">
						<div @click.stop="callback(second, [index,si])"
							 :class="secondLeft?'cm-left':''">
							<i :class="second.icon"></i>
							<span>{{second.text}}</span>
							<svg class="icon" aria-hidden="true"
								 v-if="arrow && second.children && second.children.length > 0">
								<use xlink:href="#icon-youjiantou"></use>
							</svg>
						</div>
						<!--third-->
						<ul class="cm-ul cm-ul-3 easy-cm-ul"
							:style="thirdBorderCheck(index,si)"
							:class="underline?'cm-underline':''"
							v-if="second.children && second.children.length > 0">
							<li v-for="(third, ti) in second.children"
								:style="liStyle">
								<div @click.stop="callback(third, [index,si,ti])">
									<i :class="third.icon"></i>
									<span>{{third.text}}</span>
								</div>
							</li>
						</ul>
					</li>
				</ul>
			</li>
		</ul>
	</div>
</template>

<script>
	import Vue from 'vue';
	
	const ctxMenu = {
		name: 'CtxMenu',
		data() {
			return {
				// Whether to display
				show: false,
				// Trigger point coordinates
				axis: {
					x: 0,
					y: 0
				}
			}
		},
		props: {
			tag: {},
			list: {
				required: true
			},
			// Whether to enable underline
			underline: {
				default: false
			},
			// Whether to turn on the arrow
			arrow: {
				default: false
			},
			// Whether to enable borders
			border: {
				default: true
			},
			// List item width
			itemWidth: {
				default: 140
			},
			// List item height
			itemHeight: {
				default: 36
			},
			// List item font size
			itemSize: {
				default: 14
			},
			// Display point offset
			offset: {
				default: () => {
					return {
						x: 6, y: 2
					}
				}
			},
			// border with
			borderWidth: {
				default: 6
			}
		},
		mounted() {

			this.$root.$on('ctxMenuShow', (axis) => {
				if (axis.tag == this.tag) {
					this.show = true;
					this.axis = axis;					
				}
			});

			document.addEventListener('click', () => {
				this.show = false
			}, true)
		},
		watch: {
			axis() {
				if (this.border) {
					let bw = window.innerWidth, bh = window.innerHeight;


					if (this.axis.x + this.offset.x + this.itemWidth >= bw) {
						this.axis.x = bw - this.itemWidth - this.borderWidth - this.offset.x
					}
					if (this.axis.y + this.offset.y + this.itemHeight * this.list.length >= bh) {
						this.axis.y = bh - this.itemHeight * this.list.length - this.borderWidth - this.offset.y
					}
				}
			}
		},
		computed: {
			axisComputed() {
				return {
					top: this.axis.y + this.offset.y + 'px',
					left: this.axis.x + this.offset.x + 'px'
				}
			},
			liStyle() {
				return {
					width: this.itemWidth + 'px',
					height: this.itemHeight + 'px',
					lineHeight: this.itemHeight + 'px',
					fontSize: this.itemSize + 'px'
				}
			},
			firstLeft() {
				let bw = document.body.offsetWidth
				return this.axis.x + this.itemWidth * 2 >= bw
			},
			secondLeft() {
				let bw = document.body.offsetWidth
				return this.axis.x + this.itemWidth * 3 >= bw
			}
		},
		methods: {
			secondBorderCheck(i) {
				let bw = window.innerWidth, bh = window.innerHeight;
				let cy = this.axis.y + (i + this.list[i].children.length) * this.itemHeight
				return {
					left: this.axis.x + this.itemWidth * 2 >= bw ? '-100%' : '100%',
					top: bh >= cy ? 0 : -(this.list[i].children.length - 1) * this.itemHeight + 'px'
				}
			},
			thirdBorderCheck(i, si) {
				let bw = window.innerWidth, bh = window.innerHeight;
				let cy = this.axis.y + this.list[i].children[si].children.length * this.itemHeight + (i + si) * this.itemHeight + parseInt(this.secondBorderCheck(i).top)
				return {
					left: this.axis.x + this.itemWidth * 3 >= bw ? '-100%' : '100%',
					top: cy > bh ? -(this.list[i].children[si].children.length - 1) * this.itemHeight + 'px' : 0
				}
			},
			callback(item, indexList) { //item, indexList,target
				this.$emit('ctxMenuItemClick', { item: item, index: indexList, target: this.axis.target });
			}
		}
	}

	const VueEasyCm = {
		install: function (Vue) {

			// Vue.component('ctx-menu', ctxMenu);

			Vue.prototype.$easycm = function (e, root, tag, target) {
				e.stopPropagation()
				e.preventDefault()
				root.$emit('ctxMenuShow', {
					tag: tag,
					x: e.clientX,
					y: e.clientY, 
					target : target
				})
			}
		}
	}

	Vue.use(VueEasyCm)


	export { ctxMenu as default };

</script>
